import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoomIdService } from './room-id.service';
import { UserService } from '../user/user.service';
import { AuthService } from '../user/auth.service';
import { UIMesageService } from '../common/ui-message.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ResponsiveService } from '../common/responsive.service';
import { EstimateService } from './estimate.service';
import { ResultsComponent } from './results.component';
import { GoogleAnalyticsService } from '../common/google-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { AdvertisingService } from '../common/advertising.service';
//declare const window: any;
declare global {
    interface Window {
        fusetag: any;
    }
}

@Component({
    selector: 'poker-room-not-premium',

    templateUrl: './poker-room.page.html',
    styleUrls: ['./poker-room.page.scss'],
})

export class PokerRoomPage implements OnInit, OnDestroy {
    public isLoading = true;
    public environment = environment;
    constructor(
        private route: ActivatedRoute,
        public roomIdService: RoomIdService,
        public userService: UserService,
        public authService: AuthService,
        private uiMessage: UIMesageService,
        private logger: LoggerService,
        public responsiveService: ResponsiveService,
        public estimateService: EstimateService,
        private googleAnalyticsService: GoogleAnalyticsService,
        public dialog: MatDialog,
        public advertisingService: AdvertisingService
    ) {
    }

    async ngOnInit() {
        try {
            this.roomIdService.setRoomId(this.route);
            this.isLoading = false;
            this.advertisingService.pageInit()
        } catch (error) {
            this.uiMessage.error(error, 'Initializing the room. Please check your internet connection.');
        }
    }

    ngOnDestroy(): void {
        this.advertisingService.destroy();
    }


    public get isOwner(): boolean {
        if (this.roomIdService.getCurrentRoomID() === this.userService.getRoomId()) {
            return true;
        } else {
            return false;
        }
    }


}
